export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7968.9b7c93c5.jpg";